export const GATE_TYPES = [
  { name: "dedicated", id: 1 },
  { name: "carpool", id: 2 },
  { name: "guest", id: 3 },
];
